import { render, staticRenderFns } from "./VAddress.vue?vue&type=template&id=1cdec49e&"
import script from "./VAddress.vue?vue&type=script&lang=js&"
export * from "./VAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports